import { USER_FORGOT_PASSWORD_REQUEST, USER_FORGOT_PASSWORD_SUCCESS, USER_FORGOT_PASSWORD_FAILURE } from '../../constants/password.constants';

export const forgotPasswordRequest = email => ({
    type: USER_FORGOT_PASSWORD_REQUEST,
    email,
});

export const forgotPasswordRequestSuccess = () => ({
    type: USER_FORGOT_PASSWORD_SUCCESS,
});

export const forgotPasswordRequestFailure = error => ({
    type: USER_FORGOT_PASSWORD_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/App/redux/actions/account_actions/forgot_password.actions.js